{
  "name": "homeplus",
  "version": "1.0.12",
  "group": "com.hps",
  "author": "HomePlus Services Pvt. Ltd",
  "license": "HomePlus Services Pvt. Ltd",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "build:zip": "npm run build --silent && node zip-build.js",
    "sbom": "npx cyclonedx-bom -o bom.json",
    "serve:ssr:homeplus": "node dist/homeplus/server/server.mjs",
    "release": "standard-version --preset conventionalcommits && node scripts/update-release-notes.js",
    "postversion": "node scripts/update-release-notes.js"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.1.0",
    "@angular/cdk": "^21.1.0",
    "@angular/common": "^21.1.0",
    "@angular/compiler": "^21.1.0",
    "@angular/core": "^21.1.0",
    "@angular/forms": "^21.1.0",
    "@angular/material": "^21.1.0",
    "@angular/platform-browser": "^21.1.0",
    "@angular/platform-browser-dynamic": "^21.1.0",
    "@angular/platform-server": "^21.1.0",
    "@angular/router": "^21.1.0",
    "@angular/ssr": "^21.1.0",
    "@grafana/faro-web-sdk": "^2.3.1",
    "@grafana/faro-web-tracing": "^2.3.1",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "@primeuix/themes": "^2.0.2",
    "@stomp/stompjs": "^7.2.1",
    "@tensorflow-models/blazeface": "^0.1.0",
    "@tensorflow/tfjs": "^4.22.0",
    "apexcharts": "^5.3.6",
    "buffer": "^6.0.3",
    "chart.js": "^4.5.1",
    "date-fns": "^4.1.0",
    "date-fns-tz": "^3.2.0",
    "driver.js": "^1.4.0",
    "express": "^5.1.0",
    "html2canvas": "^1.4.1",
    "jspdf": "^4.1.0",
    "jwt-decode": "^4.0.0",
    "ng-apexcharts": "^2.0.3",
    "ngx-cookie-service": "^21.1.0",
    "ngx-file-drop": "^16.0.0",
    "ngx-scrollbar": "^19.1.3",
    "primeflex": "^4.0.0",
    "primeicons": "^7.0.0",
    "primeng": "^21.0.4",
    "process": "^0.11.10",
    "razorpay": "^2.9.6",
    "recordrtc": "^5.6.2",
    "rxjs": "^7.8.2",
    "sass": "^1.94.2",
    "sockjs": "^0.3.24",
    "sockjs-client": "^1.6.1",
    "tslib": "^2.8.1",
    "zone.js": "~0.16.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^21.1.0",
    "@angular-devkit/core": "^21.1.0",
    "@angular-eslint/eslint-plugin": "^21.0.1",
    "@angular-eslint/eslint-plugin-template": "^21.0.1",
    "@angular-eslint/template-parser": "^21.0.1",
    "@angular/build": "^21.1.0",
    "@angular/cli": "^21.1.0",
    "@angular/compiler-cli": "^21.1.0",
    "@esbuild-plugins/node-globals-polyfill": "^0.2.3",
    "@grafana/faro-cli": "^0.7.7",
    "@grafana/faro-webpack-plugin": "^0.9.3",
    "@types/express": "^5.0.5",
    "@types/jasmine": "^5.1.13",
    "@types/node": "^25.0.9",
    "@types/recordrtc": "^5.6.15",
    "@types/sockjs-client": "^1.5.4",
    "@typescript-eslint/eslint-plugin": "^8.47.0",
    "@typescript-eslint/parser": "^8.47.0",
    "archiver": "^7.0.1",
    "baseline-browser-mapping": "^2.9.16",
    "eslint": "^9.39.1",
    "jasmine-core": "^6.0.0",
    "karma": "^6.4.4",
    "karma-chrome-launcher": "^3.2.0",
    "karma-coverage": "^2.2.1",
    "karma-jasmine": "^5.1.0",
    "karma-jasmine-html-reporter": "^2.1.0",
    "node-polyfill-webpack-plugin": "^4.1.0",
    "standard-version": "^9.5.0",
    "typescript": "^5.9.3"
  }
}
